var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"send-egift-panel-deposit-info"},_vm._l((_vm.items),function(item,index){return _c('deposit-info-item',{key:index,attrs:{"content":item.content,"title":item.title,"videoUrl":item.videoUrl,"expandable":index !== 0}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }